import React from "react";

import { Text, Icon } from "@ui-component-library";

import { useMetricData } from "../hooks/UseMetricData";
import { useOpenDroneCheckout } from "@components/Checkout/config/DroneCheckout/DroneCheckoutContext";
import { useDemoMinskogStore } from "../../store/DemoMinskogStore";
import { DEMO_PROMPTS } from "../../constants/demoPrompts";

export default function OpportunitiesWidget({ showDialog }) {
  const { totalArbonics } = useMetricData();
  const { openCheckout: openDroneCheckout } = useOpenDroneCheckout();
  const { DemoBlockFunctionWrapper } = useDemoMinskogStore()

  return (
    <div className="flex flex-col gap-2">
      <a
        className="flex flex-row gap-3 py-2 px-4 items-center justify-between cursor-pointer hover:bg-cloud-200"
        onClick={() => {DemoBlockFunctionWrapper(() => {window.location="/salj-virke/"}, DEMO_PROMPTS.VIRKESFORSALJNING)}}
      >
        <div className="flex flex-row gap-3 items-center min-w-0">
          <Icon name="PineTreeSimple" size="large" />
          <div className="flex flex-col">
            <Text
              variant="text-sm/leading-normal/medium"
              className="truncate"
            >
              Sälj Virke
            </Text>
            <Text
              variant="text-xs/leading-normal/normal"
              className="text-[#737373] truncate"
            >
              23% högre virkespriser
            </Text>
          </div>
        </div>
        <div className="flex flex-row gap-2 justify-between">
          <div className="flex flex-col items-end">
            <Text
              variant="text-sm/leading-normal/normal"
              className="whitespace-nowrap"
            >
              Läs mer
            </Text>
          </div>
          <Icon
            name="ArrowShortSimple"
            size="medium"
            className="rotate-180"
          />
        </div>
      </a>
      <a
        className="flex flex-row gap-3 py-2 px-4 items-center justify-between cursor-pointer hover:bg-cloud-200"
        onClick={() => {DemoBlockFunctionWrapper(() => {window.location="/salj-virke/"}, DEMO_PROMPTS.BIOBRANSLE)}}
      >
        <div className="flex flex-row gap-3 items-center min-w-0">
          <Icon name="TreeSimple" size="large" />
          <div className="flex flex-col">
            <Text variant="text-sm/leading-normal/medium" className="truncate">
              Biobränsle
            </Text>
            <Text
              variant="text-xs/leading-normal/normal"
              className="text-[#737373] truncate"
            >
              Fler anbud, bättre köpare
            </Text>
          </div>
        </div>
        <div className="flex flex-row gap-2 justify-between">
          <div className="flex flex-col items-end">
            <Text
              variant="text-sm/leading-normal/normal"
              className="whitespace-nowrap"
            >
              Läs mer
            </Text>
          </div>
          <Icon
            name="ArrowShortSimple"
            size="medium"
            className="rotate-180"
          />
        </div>
      </a>
      <div
        className="flex flex-row gap-3 py-2 px-4 items-center justify-between cursor-pointer hover:bg-cloud-200"
        onClick={() => {DemoBlockFunctionWrapper(openDroneCheckout, DEMO_PROMPTS.DRONE_ORDER)}}
      >
        <div className="flex flex-row gap-3 items-center min-w-0">
          <Icon name="DroneSimple" size="large" />
          <div className="flex flex-col min-w-0">
            <Text variant="text-sm/leading-normal/medium" className="truncate">
              Drönarflygning
            </Text>
            <Text
              variant="text-xs/leading-normal/normal"
              className="text-[#737373] truncate"
            >
              Högupplösa bilder från din fastighet.
            </Text>
          </div>
        </div>
        <div className="flex flex-row gap-2 justify-between">
          <div className="flex flex-col items-end">
            <Text
              variant="text-sm/leading-normal/normal"
              className="whitespace-nowrap"
            >
              Läs mer
            </Text>
          </div>
          <Icon
            name="ArrowShortSimple"
            size="medium"
            className="rotate-180"
          />
        </div>
      </div>

      {totalArbonics?.eligible === 2 ? (
        <a
          className="flex flex-row gap-3 py-2 px-4 items-center justify-between cursor-pointer hover:bg-cloud-200"
          onClick={() => {DemoBlockFunctionWrapper(showDialog, DEMO_PROMPTS.KOLKREDITER)}}
        >
          <div className="flex flex-row gap-3 items-center">
            <Icon name="CarbonDioxideSimple" size="large" />
            <div className="flex flex-col">
              <Text variant="text-sm/leading-normal/medium">
                Potential Kolkrediter
              </Text>
            </div>
          </div>
          <div className="flex flex-row gap-2 justify-between">
            <div className="flex flex-row items-baseline gap-1 truncate min-[993px]:hidden min-[1300px]:flex ">
              <Text variant="text-sm/leading-normal/normal">Ja</Text>
            </div>
            <Icon
              name="ArrowShortSimple"
              size="medium"
              className="rotate-180"
            />
          </div>
        </a>
      ) : (
        <div className="flex flex-row gap-3 py-2 px-4 items-center justify-between">
          <div className="flex flex-row gap-3 items-center">
            <Icon name="CarbonDioxideSimple" size="large" />
            <div className="flex flex-col">
              <Text variant="text-sm/leading-normal/medium">
                Potential Kolkrediter
              </Text>
            </div>
          </div>
          <div className="flex flex-row gap-2 justify-between">
            <div className="flex flex-row items-baseline gap-1 truncate min-[993px]:hidden min-[1300px]:flex ">
              <Text variant="text-sm/leading-normal/normal">Nej</Text>
            </div>
            <div />
          </div>
        </div>
      )}

      {totalArbonics?.eligible === 2 && (
        <a
          className="flex flex-row gap-3 py-2 px-4 items-center justify-between cursor-pointer hover:bg-cloud-200"
          onClick={() => {DemoBlockFunctionWrapper(showDialog, DEMO_PROMPTS.KOLKREDITER)}}
        >
          <div className="flex flex-row gap-2 justify-between w-full">
            <div className="flex flex-row gap-3 items-center min-w-0">
              <Icon name="CheckSquareSimple" size="large" />
              <Text
                variant="text-sm/leading-normal/medium"
                className="truncate"
              >
                Tjäna kolkrediter
              </Text>
            </div>

            <div className="flex flex-row gap-2 justify-between">
              <div className="flex flex-col items-end">
                <Text variant="text-sm/leading-normal/normal">Klicka här</Text>
              </div>
              <Icon
                name="ArrowShortSimple"
                size="medium"
                className="rotate-180"
              />
            </div>
          </div>
        </a>
      )}
    </div>
  );
}
